// extracted by mini-css-extract-plugin
module.exports = {"section":"YoutubeSectionRW_section__v5VOa YoutubeSection_section__Y9SpF","title":"YoutubeSectionRW_title__KdSr_ YoutubeSection_title__RMxZQ"};